const user = [
  {
    path: "infor",
    name: "infor",
    meta: {
      title: "客户概况"
    },
    component: () => import("../../views/user/infor.vue")
  },
  // 客户管理
  // {
  //   path: "userManage/userInquire",
  //   name: "userInquire",
  //   meta: {
  //     title: "客户查询"
  //   },
  //   component: () => import("../../views/user/userManage/userInquire.vue")
  // },
  {
    path: "userManage/userCrowd",
    name: "userCrowd",
    meta: {
      title: "客户分群"
    },
    component: () => import("../../views/user/userManage/userCrowd.vue")
  },
  {
    path: "userManage/userImport",
    name: "userImport",
    meta: {
      title: "客户导入"
    },
    component: () => import("../../views/user/userManage/userImport.vue")
  },
  {
    path: "userManage/labelManage",
    name: "labelManage",
    meta: {
      title: "标签管理"
    },
    component: () => import("../../views/user/userManage/labelManage.vue")
  },
  // 客户运营
  {
    path: "userOperation/crowdOperat",
    name: "crowdOperat",
    meta: {
      title: "人群运营"
    },
    component: () => import("../../views/user/userOperation/crowdOperat.vue")
  },
  {
    path: "userOperation/addCrowdOperat",
    name: "addCrowdOperat",
    meta: {
      title: "操作人群运营"
    },
    component: () => import("../../views/user/userOperation/addCrowdOperat.vue")
  },
  {
    path: "userOperation/sceneOperat",
    name: "sceneOperat",
    meta: {
      title: "场景运营"
    },
    component: () => import("../../views/user/userOperation/sceneOperat.vue")
  }
];

export default user;
